import { API } from "./api";

export function getSessionId() {
  try {
    let sid = sessionStorage.getItem("ac_sid");
    if (!sid) {
      sid =
        (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
        Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem("ac_sid", sid);
    }
    return sid;
  } catch {
    return "anon-" + Date.now().toString(36);
  }
}

export function getStoredSource() {
  try {
    const raw = sessionStorage.getItem("ac_last_source");
    if (!raw)
      return { referrer: document.referrer || "", utm_source: "", utm_medium: "", utm_campaign: "", session_id: getSessionId() };
    const parsed = JSON.parse(raw);
    return {
      referrer: parsed.referrer || document.referrer || "",
      utm_source: parsed.utm_source || "",
      utm_medium: parsed.utm_medium || "",
      utm_campaign: parsed.utm_campaign || "",
      session_id: parsed.session_id || getSessionId(),
    };
  } catch {
    return { referrer: document.referrer || "", utm_source: "", utm_medium: "", utm_campaign: "", session_id: getSessionId() };
  }
}

export function trackPageView(path) {
  try {
    const params = new URLSearchParams(window.location.search);
    const payload = {
      path,
      referrer: document.referrer || "",
      session_id: getSessionId(),
      screen: window.innerWidth < 768 ? "mobile" : "desktop",
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
    };
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
    try {
      sessionStorage.setItem(
        "ac_last_source",
        JSON.stringify({
          referrer: payload.referrer,
          utm_source: payload.utm_source,
          utm_medium: payload.utm_medium,
          utm_campaign: payload.utm_campaign,
          session_id: payload.session_id,
        })
      );
    } catch {}
  } catch {}
}
